import { gql } from "@apollo/client"

export const UpdateBlog = gql`
mutation UpdateBlog($updateBlogId: ID!, $content: contentBlog!) {
  updateBlog(id: $updateBlogId, content: $content) {
    status
  }
}
`